var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.enabled
    ? _c(
        "section",
        { staticClass: "buttons has-addons", attrs: { id: "zoombar" } },
        [
          _vm.geolocationEnabled
            ? _c(
                "button",
                {
                  staticClass:
                    "zoom-out button is-dark has-background-black-bis",
                  attrs: { type: "button" },
                  on: { click: _vm.locate }
                },
                [
                  _c("b-icon", {
                    attrs: { icon: _vm.geolocation, type: "", size: "is-small" }
                  })
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "zoom-out button is-dark has-background-black-bis",
              attrs: { type: "button" },
              on: { click: _vm.zoomOut }
            },
            [_c("b-icon", { attrs: { icon: "minus", type: "", size: "" } })],
            1
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "zoom-in button is-dark has-background-black-bis",
              attrs: { type: "button" },
              on: { click: _vm.zoomIn }
            },
            [_c("b-icon", { attrs: { icon: "plus", type: "", size: "" } })],
            1
          )
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }